import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import firebase from "firebase";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import Aux from "../hoc/Aux";
import ModalAttention from "../hoc/ModalAttention";

import { handlefacebook } from "../../assets/js/loginFacebook";
import { handlegoogle } from "../../assets/js/loginGoogle";
import search from "../../assets/img/search.png";
import IconName from "../../assets/img/alerta-celular.png";

import instance from "../../services/axios";
import { auth } from "../../services/Firebase";
import api from "../../services/Api";

import { checkEMAIL, checkPASS } from "../../libs/Validate";

export default class Login extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      Cadastro: false,
      isLoggedIn: false,
      error: false,
      isLogging: false,
      usuarios: {},
      modal: false,
      emailRec: "",
      syncApi: false,
      ModalE: false,
      userInApp: false,
      textErr: false,
      emailOk: false,
      passwordOk: false,
      captOk: false,
      errorText: "",
    };
    this.email = null;
    this.passwd = null;
  }

  componentWillMount() {
    auth.onAuthStateChanged(async (data) => {
      if (data) {
        if (data.emailVerified === true) {
          instance.defaults.headers.Authorization = data._lat;
          api
            .loadApi()
            .then((resp) => {
              this.setState({ userInApp: !!resp });
            })
            .catch((err) => {
              this.setState({ userInApp: false });
            });
        } else {
          this.setState({
            isLoggedIn: false,
            isLogging: false,
            syncApi: false,
          });
        }
      }
    });
  }

  componentDidMount() {
    this.render();
  }

  componentWillUnmount() {
    this.setState({ userInApp: undefined });
  }

  reload = () => {
    this.componentDidMount();
  };

  checkField = (e) => {
    const campo = e.target.id;
    const valor = e.target.value;

    switch (campo) {
      case "inputUsernameEmail":
        this.setState({ emailOk: checkEMAIL(valor) });
        break;
      case "inputPassword":
        this.setState({ passwordOk: checkPASS(valor) });
        break;
      default:
    }
  };

  toggle = () => {
    this.setState({ modal: !this.state.modal, textErr: false });
  };

  isEnabledEntrar = () => {
    return this.state.captOk && this.state.emailOk && this.state.passwordOk;
  };

  onLoginFace = () => {
    handlefacebook()
      .then((resp) => {
        if (
          resp.code === "auth/network-request-failed" ||
          resp.code === "auth/popup-closed-by-user"
        ) {
          // this.setState({ ModalE: true, errorText: 'Error ao tentar entrar pelo Google/Facebook' })
        } else {
          this.setState({
            isLoggedIn: true,
            syncApi: true,
          });
        }
      })
      .catch((err) => {
        this.setState({ ModalE: true, errorText: "Error ao tentar entrar pelo Google/Facebook" });
      });
  };

  onLoginGoogle = async () => {
    await handlegoogle()
      .then((resp) => {
        if (
          resp.code === "auth/popup-closed-by-user" ||
          resp.code === "auth/network-request-failed"
        ) {
          // this.setState({ ModalE: true, errorText: 'Error ao tentar entrar pelo Google/Facebook' })
        } else {
          this.setState({
            isLoggedIn: true,
            syncApi: true,
          });
        }
      })
      .catch((err) => {
        console.log("ERROR:", err);
        this.setState({ ModalE: true, errorText: "Error ao tentar entrar pelo Google/Facebook" });
      });
  };

  onLogin = async (event) => {
    event.preventDefault();
    if (this.state.emailOk === true && this.state.passwordOk === true) {
      this.setState({
        isLogging: true,
        error: false,
      });

      await firebase
        .auth()
        .signInWithEmailAndPassword(this.email.value, this.passwd.value)
        .then(async (user) => {
          if (user.emailVerified === false) {
            this.email.value = "";
            this.passwd.value = "";
            this.setState({
              isLoggedIn: false,
              isLogging: false,
              syncApi: false,
              ModalE: true,
              errorText: "Seu e-mail não foi verificado, favor olhe sua caixa de e-mail",
            });
          } else if (user.emailVerified === true) {
            const token = user._lat;
            instance.defaults.headers.Authorization = token;
            this.setState({
              isLoggedIn: true,
              syncApi: true,
            });
          }
        })
        .catch((error) => {
          this.passwd.value = "";
          this.reload();
          this.setState({
            error: true,
            isLogging: false,
            ModalE: true,
            errorText: "Usuario ou Senha Incorretas",
          });
        });
    } else {
      this.setState({
        ModalE: true,
        errorText: "Preencha os campos corretamente",
      });
    }
  };

  onModalE = (event) => {
    this.setState({ ModalE: !this.state.ModalE });
  };

  onRecuperarSenha = async () => {
    const auth = firebase.auth();
    await auth
      .sendPasswordResetEmail(this.emailRecover.value, {
        url: "http://alertacelular.al.gov.br/",
      })
      .then(async () => {
        await this.setState({ modal: !this.state.modal, textErr: false });
        await this.props.handleSucess();
      })
      .catch((error) => {
        this.setState({ textErr: true });
      });
  };

  onChangeRecaptcha = (value) => {
    if (value) this.setState({ captOk: true });
  };

  render() {
    if (this.state.Cadastro) return <Redirect to="/formulario" />;
    if ((this.state.isLoggedIn && this.state.syncApi) || this.state.userInApp)
      return <Redirect to="/dashboard" />;

    return (
      <Aux>
        <div className="container ContainerIconAlerta">
          <div className="DivIconAlerta2">
            <img src={IconName} width="80%" height="80%" alt="" />
          </div>
        </div>
        <div className="Login">
          <div className="social-networks">
            <a onClick={this.onLoginGoogle} className="btn btn-lg ggle">
              <div className="div-google">
                <img className="img-google mr-2" src={search} width="20px" height="20px" alt="" />
                <span className="text-google">Google</span>
              </div>
            </a>
          </div>
          <form>
            <div className="form-group InputEmail">
              <div className="input-group mb-3 ">
                <div className="input-group-prepend ">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fas fa-user" />
                  </span>
                </div>
                <input
                  type="email"
                  className="form-control "
                  placeholder="Informe seu Email"
                  aria-label="Informe seu Email"
                  aria-describedby="basic-addon1"
                  ref={(ref) => (this.email = ref)}
                  onChange={this.checkField}
                  id="inputUsernameEmail"
                />
              </div>
            </div>
            <div className="form-group InputEmail">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fas fa-lock" />
                  </span>
                </div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Digite sua senha"
                  aria-label="Digite sua senha"
                  aria-describedby="basic-addon1"
                  ref={(ref) => (this.passwd = ref)}
                  onChange={this.checkField}
                  id="inputPassword"
                />
              </div>
            </div>
            <div className="form-row InputEmail">
              <div className="col-6 text-left">
                <label>
                  <input type="checkbox" className="mr-2" />
                  Lembrar-me?
                </label>
              </div>
              <div className="col-6 text-right" style={{ right: "9%" }}>
                <a href className="text-link" onClick={this.toggle}>
                  {this.props.buttonLabel} Esqueci minha senha
                </a>
              </div>
            </div>
            <div className="form-row justify-content-center InputEmail">
              <ReCAPTCHA
                ref={(el) => (this.captcha = el)}
                size="normal"
                sitekey="6LdF2XYUAAAAAKyH6cV6_6bAIHlu8LBgIPw5E2jj"
                onChange={this.onChangeRecaptcha}
              />
            </div>
            <div className="form-row InputEmail text-center">
              <button
                className="btn btn-secondary button-entrar"
                disabled={!this.isEnabledEntrar()}
                type="submit"
                onClick={this.onLogin}
              >
                <span>Entrar</span>
              </button>
            </div>
            <div className="form-row justify-content-center InputEmail">
              <a
                href
                className="text-link btn-cadastrar"
                onClick={() => this.setState({ Cadastro: true })}
              >
                {this.props.buttonLabel} Cadastrar
              </a>
            </div>
          </form>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ color: "black" }}
        >
          <ModalHeader toggle={this.toggle} style={{ color: "black" }}>
            Esqueci Minha senha!
          </ModalHeader>
          <ModalBody style={{ color: "black" }}>
            {this.state.textErr ? (
              <div>
                <br />
                <p style={{ color: "red" }}>E-mail não encontrado ou inválido</p>
              </div>
            ) : null}
            Informe seu e-mail para ser reenviado um link para criar uma nova senha.
            <br />
            <a>Email*</a>
            <br />
            <input
              type="email2"
              className="form-control"
              ref={(ref) => (this.emailRecover = ref)}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onRecuperarSenha}>
              Enviar
            </Button>{" "}
            <Button color="secondary" onClick={this.toggle}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <ModalAttention
          title={this.state.ModalTitle}
          show={this.state.ModalE}
          toggle={this.onModalE}
          ok={() => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                this.setState({ ModalE: false, errorText: "" });
              })
              .catch((err) => {});
          }}
        >
          <p style={{ color: "black" }}>{this.state.errorText}</p>
        </ModalAttention>
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/Login.js